'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbSlideshowController($scope) {
    var vm = this;

    // Inputs
    vm.autoPlay = this.autoPlay;
    vm.slideDuration = this.slideDuration;
    vm.activeSlideIndex = 0;
    vm.fixedHeight = this.height;

    // Nr of slides
    vm.slides = this.slides = [];

    vm.addSlide = function (slide, domNode) {
        // Assign index
        slide.index = vm.slides.length;
        slide.css = {
            transform: 'translateX(' + (slide.index + 1) * 100 + '%)'
        };
        slide.domNode = domNode;
        vm.slides.push(slide);
    };

    vm.setActive = function (slide) {
        angular.forEach(vm.slides, function (slide) {
            slide.isActive = false;
        });
        slide.isActive = true;
        if (vm.fixedHeight) {
            vm.height = vm.fixedHeight;
        } else {
            vm.height = slide.domNode.offsetHeight;
        }
        vm.activeSlideTrack = {
            transform: 'translateX(' + (slide.index + 1) * -100 + '%)',
            height: vm.height + 'px'
        };
        // Nudge the change detection
        setTimeout(function () {
            $scope.$apply();
        });
    };

    vm.startAutoPlay = function () {
        vm.stopAutoPlay();
        vm.autoPlay = true;
        vm.startAutoPlay.intRef = setInterval(function () {
            if (vm.slides.length > vm.activeSlideIndex + 1) {
                vm.activeSlideIndex++;
            } else {
                vm.activeSlideIndex = 0;
            }
            vm.setActive(vm.slides[vm.activeSlideIndex]);
        }, vm.slideDuration);
    };

    vm.stopAutoPlay = function () {
        vm.autoPlay = false;
        clearInterval(vm.startAutoPlay.intRef);
    };

    // After all methods and props are defined. Init the directive.
    (vm.init = function () {
        setTimeout(function () {
            vm.setActive(vm.slides[0]);
            if (vm.autoPlay && vm.autoPlay !== 'false') {
                vm.startAutoPlay();
            }
        });
    })();
}

cbSlideshowController.$inject = ['$scope'];

exports.default = cbSlideshowController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/slideshow/cb-slideshow.controller.js
// module id = 414
// module chunks = 0